module.exports = __webpack_public_path__ + "img/up.1f3dd98a.png";